import { AnyAction, combineReducers } from 'redux';

import { CUSTOMER_DETAIL_RESET } from './customer-detail-actions';
import {
    CustomerConditionsReducerState,
    customerConditionsReducer,
} from '../conditions/store/customer-conditions-reducer';
import {
    CustomerDetailDocumentsReducerState,
    customerDetailDocumentsReducer,
} from '../documents/store/customer-detail-documents-reducer';
import { CustomerDetailGlobalReducerState, customerDetailGlobalReducer } from './customer-detail-global-reducer';
import {
    CustomerDetailOverviewReducerState,
    customerDetailOverviewReducer,
} from '../overview/store/customer-detail-overview-reducers';
import { CustomerDetailTopicReducerState, customerDetailTopicReducer } from '../topics/store/customer-topics-reducer';
import { CustomerEmployeeReducerState, customerEmployeeReducer } from '../employees/store/customer-employee-reducer';
import {
    customerExternalCustomerMappingReducer,
    customerExternalCustomerMappingReducerState,
} from '../external-customer-mapping/store/customer-external-customer-mapping-reducer';

export interface CustomerDetailReducerState {
    global: CustomerDetailGlobalReducerState;
    overview: CustomerDetailOverviewReducerState;
    employees: CustomerEmployeeReducerState;
    conditions: CustomerConditionsReducerState;
    documents: CustomerDetailDocumentsReducerState;
    topics: CustomerDetailTopicReducerState;
    supplierExternalCustomerMappings: customerExternalCustomerMappingReducerState;
}

const combinedCustomerDetailReducer = combineReducers<CustomerDetailReducerState>({
    global: customerDetailGlobalReducer,
    overview: customerDetailOverviewReducer,
    employees: customerEmployeeReducer,
    conditions: customerConditionsReducer,
    documents: customerDetailDocumentsReducer,
    topics: customerDetailTopicReducer,
    supplierExternalCustomerMappings: customerExternalCustomerMappingReducer,
});

const initialCustomerDetailReducerState: CustomerDetailReducerState = combinedCustomerDetailReducer(undefined, {
    type: '',
});

export const customerDetailReducer = (
    state: CustomerDetailReducerState = initialCustomerDetailReducerState,
    action: AnyAction
): CustomerDetailReducerState => {
    switch (action.type) {
        case CUSTOMER_DETAIL_RESET:
            return combinedCustomerDetailReducer(undefined, action);
        default:
            return combinedCustomerDetailReducer(state, action);
    }
};
